import React from 'react'
import { useHookstate } from '@hookstate/core'
import { Col, Row } from 'react-bootstrap'
import { useExhibitorDataState } from '../../globalStates/ExhibitorDataState'
import { useLanguageState } from '../../globalStates/LanguageState'
import { getElementFieldValue, makeSetHandler } from '../../globalStates/utils'
import TextField from '../../components/Field/Text'
import Section from '../../components/Section'

const FrameSection: React.FC<{}> = () => {
    const branding = useLanguageState().getStrings()
    const organizationState = useExhibitorDataState().getOrganization()
    const organization = useHookstate(organizationState)
    return (
        <Section title={branding.configuration.profilePage.sctiFrame.lbliFrame}>
            <Row>
                <Col>
                    <TextField
                        id="iframeURL"
                        name="iframeURL"
                        label={branding.configuration.profilePage.sctiFrame.lbliFrameURL}
                        placeholder={branding.configuration.profilePage.sctiFrame.hntiFrameUR}
                        value={getElementFieldValue(organization, "iframeUrl")}
                        onChange={makeSetHandler(organization, 'iframeUrl')}
                    />
                </Col>
                <Col>
                    <TextField
                        id="iframeURLde"
                        name="iframeURLde"
                        label={branding.configuration.profilePage.sctiFrame.lbliFrameURLDE}
                        placeholder={branding.configuration.profilePage.sctiFrame.hntiFrameURLDE}
                        value={getElementFieldValue(organization, "iframeUrlDe")}
                        onChange={makeSetHandler(organization, 'iframeUrlDe')}
                    />
                </Col>
            </Row>
        </Section>
    );
}

export default FrameSection
